import React from 'react'
import { ModelCategory } from '../../../types/faq/faq_model'
import iconsEnum from '../../../enums/iconsEnum'
import Icon from '../../../components/icon/Icon'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../../styles'
import { useMediaQuery } from 'react-responsive'
import { ClassValue } from 'classnames/types'
import classNames from 'classnames'
import Link from '../../../components/link/Link'
import { useHistory } from 'react-router'
import links from '../../../enums/linksEnum'

const useStyle = makeStyles(
    (theme) => (
        {
            ...styles(theme),
            categoryContainerStyle: {
                background: 'white'
            },
            categoryContainerLargeScreenStyle: {
                padding: '32px 24px 37px',
                width: 245,
                boxSizing: 'border-box',

                '& h1': {
                    margin: '24px 0 15px'
                }
            },
            categoryContainerSmallScreenStyle: {
                padding: '21px 18px',
                marginBottom: 15,

                '&:last-child': {
                    marginBottom: 0
                }
            },
            icon: {
                fill: theme.palette.blue.main
            },
            titleClassSmallScreenStyle: {
                marginLeft: 20
            }
        }
    )
)

interface AcceptingProps {
    category: ModelCategory
}

type CategoriesCardProps = AcceptingProps
const CategoriesCard: React.FC<CategoriesCardProps> = (
    {
        category
    }
) => {
    const classes = useStyle()
    const history = useHistory()
    const isLargeScreen = useMediaQuery(
        {
            query: '(min-width: 1025px)'
        }
    )

    const categoryContainerClass: ClassValue = classNames(
        classes.categoryContainerStyle,
        {
            [classes.categoryContainerLargeScreenStyle]: isLargeScreen,
            [classes.categoryContainerSmallScreenStyle]: !isLargeScreen,
            [classes.flex]: !isLargeScreen,
            [classes.alignCenter]: !isLargeScreen
        }
    )

    const titleClass: ClassValue = classNames(
        classes.colorBlue,
        {
            [classes.title5]: isLargeScreen,
            [classes.text5]: !isLargeScreen,
            [classes.titleClassSmallScreenStyle]: !isLargeScreen
        }
    )

    const goToCategory = (category: string) => {
        history.push({
            pathname: links.questions,
            hash: category
        })
    }

    return (
        <div
            className={categoryContainerClass}
            onClick={!isLargeScreen ? () => goToCategory(category.name) : undefined}
        >
            <Icon
                size={isLargeScreen ? 50 : 40}
                icon={category.icon ? iconsEnum[category.icon] : iconsEnum.Default}
                className={classes.icon}
            />

            <h1 className={titleClass}>
                {category.name}
            </h1>

            {
                isLargeScreen && category.themes.map(
                    (theme) => (
                        <Link
                            color="colorBlue"
                            textStyle="text3_opacity"
                            onClick={() => goToCategory(category.name)}
                            hasChevron={false}
                            key={theme.name}
                        >
                            {theme.name}
                        </Link>
                    )
                )
            }
        </div>
    )
}

export default CategoriesCard
